import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative py-24 sm:py-32 min-h-fit" }
const _hoisted_2 = {
  id: "how-it-works",
  class: "max-w-2xl mx-auto text-center flex flex-col justify-center items-center"
}
const _hoisted_3 = { class: "mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3" }
const _hoisted_4 = { class: "relative w-full" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "max-w-xl" }
const _hoisted_7 = { class: "group relative" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import choose from '@/assets/images/landing/howItWorks/goblin-choose.webp';
import vibes from '@/assets/images/landing/howItWorks/goblin-vibes.webp';
import success from '@/assets/images/landing/howItWorks/goblin-success.webp';


export default /*@__PURE__*/_defineComponent({
  __name: 'HowItWorksSection',
  setup(__props) {

const { t } = useI18n();

// Computed
const howItWorks = computed(() => [
  {
    id: 1,
    title: t('home.howItWorks.title1'),
    imageUrl: choose,
    description:
      t('home.howItWorks.description1'),
  },
  {
    id: 2,
    title: t('home.howItWorks.title2'),
    imageUrl: vibes,
    description:
      t('home.howItWorks.description2'),
  },
  {
    id: 3,
    title: t('home.howItWorks.title3'),
    imageUrl: success,
    description:
      t('home.howItWorks.description3'),
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UiContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UiTitle, {
            animation: "fadeIn",
            code: _unref(t)('home.howItWorks.tag')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('home.howItWorks.title')), 1)
            ]),
            _: 1
          }, 8, ["code"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(howItWorks.value, (howItWork) => {
            return (_openBlock(), _createElementBlock("article", {
              key: howItWork.id,
              class: "flex flex-col items-start justify-start"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: howItWork.imageUrl,
                  alt: "",
                  class: "aspect-square w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
                }, null, 8, _hoisted_5),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 rounded-2xl ring-1 ring-gray-900/10 ring-inset" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(UiTitle, {
                    type: "h3",
                    size: "xl",
                    align: "left",
                    color: "gray",
                    class: "mt-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(howItWork.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(UiParagraph, {
                    size: "lg",
                    align: "left",
                    color: "gray",
                    class: "mt-8"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(howItWork.description), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})